import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../../../shared/notifiers/base-notifier';
import { Ref } from '../../../../shared/providers/ref';
import { ViewMode } from '../../../../shared/enums/view-mode.enum';
import { ViewModeState } from './view-mode-state';

@Injectable()
export class ViewModeNotifier extends BaseNotifier<ViewModeState> {
  constructor(ref: Ref) {
    super(ref, { mode: ViewMode.Map });
  }

  toggleMode(): void {
    const current = this.snapshot().mode;
    this.setState({ mode: current === ViewMode.Map ? ViewMode.Scene : ViewMode.Map });
  }

  setMode(mode: ViewMode): void {
    this.setState({ mode });
  }
}
